export default "__VITE_ASSET__a192d196__"